import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { useSelector } from "react-redux";
import { isEmpty, CellType} from '../modules/appLibrary';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@mui/material/Box';

const useStyles = makeStyles((theme) => ({
    chip: {
        margin: theme.spacing(0.2),
    },
}));
//--------------------------------------------------------
//  リスト入力用Render
//
//  columninfo：カラム情報
//  tabvalue:0:maintable 他:subtable
//  clicked:masterlist callback
//  deletetag:tag delete callback
//--------------------------------------------------------
export default function RenderListEdit(props) {
    const entrylock = useSelector(state => state.form.entryformlock);
    const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
    const formstatus = useSelector(state => state.form.status);
    const warndescription = useSelector(state => state.form.warndiscription);
    const convdescription = useSelector(state => state.form.convdiscription);
    const CELLTYPE = CellType();
    const classes = useStyles();

    function ButtonClick(e) {
        if(editable()) props.clicked(props);
    }
    function SwitchClick(e) {
        let rowNode = props.api.getRowNode(props.data.rowid);
        var options = props.colDef.colinfo.options;
        //props.columninfoの内容を優先（税率切り替え等）
        if (props.columninfo.some(e => e.columnid === props.colDef.colId)) {
            var col = props.columninfo.find(e => e.columnid === props.colDef.colId);
            options = col.options;
        }
        if (isEmpty(props.value)) {
            rowNode.setDataValue(props.colDef.colId, options[0].code);
        } else {
            var idx = options.findIndex(e => e.code === props.value);
            if (options.length -1 === idx) {
                rowNode.setDataValue(props.colDef.colId, options[0].code);
            } else {
                rowNode.setDataValue(props.colDef.colId, options[idx+1].code);
            }
        }
    }
    function editable() {
        if (typeof props.colDef.editable === 'function') {
            return props.colDef.editable(props);
        } else {
            return props.colDef.editable;
        }
    }
    //TAG Delete
    //function handleDelete(deletetag) {
    //    const tags = replaceall(cellValue, "　", " ").split(' ');
    //    const newtags = tags.filter(function (tag) {
    //        return tag!==deletetag;
    //    });
    //    props.deletetag(props, newtags.join(' '));
    //};

    //function TagRender(param) {
    //    if (isEmpty(cellValue))
    //        return cellValue;
    //    const tags = replaceall(cellValue, "　", " ").split(' ');
    //    return tags.map(
    //        (tag) =>
    //            <Chip
    //                size="small"
    //                variant="outlined"
    //                color="primary"
    //                style={{ color: "#333", height:20 }}
    //                label={tag}
    //                onDelete={formstatus==='VIEW'?undefined: ()=> handleDelete(tag)}
    //                className={classes.chip} />
    //   );
    //}

    function WarnTip(param) {
        return (
            <Tooltip title={ param.msg}>
                <div style={{ position: 'absolute', top: -7, left: -2, cursor: 'pointer' }}>
                    {param.conv ? < span class="material-icons convert">check_circle</span> : < span class="material-icons warning">announcement</span>}
                </div>
            </Tooltip>
        );
    }

    function CheckClick(param) {
        if (!editable()) return;
        if (isEmpty(props.data)) return;
        let rowNode = props.api.getRowNode(props.data.rowid);
        rowNode.setDataValue(props.colDef.colId, param.value === "1" ? "0" : "1");
        if (!isEmpty(props.checkedchange)) {
            props.checkedchange(props, param.value === "1" ? "0" : "1");
        }
    }
    function iconcursor() {
        if (!props.colDef.editable || entrylock) return 'default';
        return 'pointer';
    }
    function RenderCheck(param) {
        let cursor = iconcursor();
        return (
            <IconButton title={param.value === "1" || param.value === 1 ? param.on : param.off}
                        style={{ cursor: cursor }}
                        size="small" onClick={props.colDef.editable && !entrylock ? () => CheckClick(param) : null}>
                {param.value === "1" || param.value ===1 ?
                    <Icon>check_box</Icon>
                    :
                    <Icon>check_box_outline_blank</Icon>
                }
            </IconButton>
        );
    }
    //function RenderStickey(param) {
    //    let Value = "";
    //    let mark = "";
    //    let color = "";
    //    if (props.colDef.colId in props.data) {
    //        let data = props.data[props.colDef.colId];
    //        if (typeof data === 'object') {
    //            if ('note' in data) Value = data.note;
    //            if ('mark' in data) {
    //                mark = data.mark;
    //                color = data.color;
    //            }
    //        }
    //    }
    //    let title = mark.length !== 0 ? mark + "/" + color : "";
    //    return <div title={title}>
    //        <IconButton size="small" onClick={props.colDef.editable && !entrylock ? ButtonClick : null}>
    //            {mark === undefined || mark === '' ?
    //                <Icon style={{ color: 'white' }}>arrow_right</Icon> :
    //                <Icon style={{ color: color }}>{mark}</Icon>
    //            }
    //        </IconButton>
    //        {Value}
    //    </div>
    //}
    function RenderBody() {
        if (props.column.colId === "expand") {
            return  <IconButton size="small"><Icon>expand_more</Icon></IconButton>
       }
        if(isEmpty(props.columninfo)) return <div>{cellValue}</div>
        let status = formstatus;
        const column = props.colDef.colinfo;

        if (isEmpty(column))
            return <div>{cellValue}</div>

        //if (column.datatype === CELLTYPE.STICKY) {
        //    return <RenderStickey />
        //}
        if (column.datatype === CELLTYPE.CHECK) {
            let on = '';
            let off = '';
            if (!isEmpty( column.options)) {
                let item = column.options.find(e => e.code === "1");
                if (!isEmpty(item)) on = item.name;
                item = column.options.find(e => e.code === "0");
                if (!isEmpty(item)) off = item.name;
            }
            return <RenderCheck value={cellValue} on={on} off={off} />
        }

        if ((status === 'VIEW' || status === undefined) && column.datatype !== CELLTYPE.TAG)
            return <div>{cellValue}</div>

        const exmaster = (status === 'INSERT' && column.primary && props.tabvalue !== "0" && !column.subtable);

        let warning = false;
        let warnmsg = "";
        let convert = false;
        if (warndescription.length !== 0) {
            const warn = warndescription.find(e => e.rowid === props.data.rowid && e.col === props.colDef.colId);
            if (!isEmpty(warn)) {
                warning = true;
                warnmsg = warn.message;
            }
        }
        if (convdescription.length !== 0) {
            const conv = convdescription.find(e => e.rowid === props.data.rowid && e.col === props.colDef.colId);
            if (!isEmpty(conv)) {
                warning = true;
                warnmsg = conv.message;
                convert = true;
            }
        }
        try {
            if ((column.locked || !props.colDef.editable) && column.datatype !== CELLTYPE.TAG)
                return (
                    <div>
                        {cellValue}
                        {warning ? <WarnTip msg={warnmsg} conv={convert} /> : null}
                    </div>
                );

            if (!exmaster && (column.datatype === CELLTYPE.TEXT || column.datatype === CELLTYPE.NUM || column.datatype === CELLTYPE.TEXTAREA)) {
                return (
                    <div style={{ position: 'rerative' }}>
                        {cellValue}
                        {warning ? <WarnTip msg={warnmsg} conv={ convert } /> : null}
                        {column.history ?
                            <div data-list-edit-trigger="true" style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} onClick={ButtonClick}>
                                <IconButton data-list-edit-trigger="true" size="small" tabIndex={-1}>
                                    <Icon>arrow_right</Icon>
                                </IconButton>
                            </div>
                            :null
                        }
                    </div>
                );
            }
            if (column.datatype === CELLTYPE.DATE || column.datatype === CELLTYPE.SEARCHYM || column.datatype === CELLTYPE.YEAR) {
                return (
                    <div style={{ position: 'rerative' }}>
                        {cellValue}
                        {warning ? <WarnTip msg={warnmsg} conv={convert} /> : null}
                        {editable() ?
                            <div data-list-edit-trigger="true" style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} onClick={ButtonClick}>
                                <IconButton data-list-edit-trigger="true" size="small" tabIndex={-1}>
                                    <Icon>arrow_right</Icon>
                                </IconButton>
                            </div>
                            : null}
                    </div>
                );
            }
            if (column.datatype === CELLTYPE.COLOR) {
                return (
                    <div style={{ position: 'rerative' }}>
                        {isEmpty(cellValue)?null:
                        <Box
                            sx={{
                                mt:0.5, width: 20, height: 20,
                                backgroundColor:  cellValue 
                            }}
                            />
                        }
                        <div style={{ position: 'absolute', top: 0, left: 38 }}>
                            {cellValue}
                        </div>
                        {warning ? <WarnTip msg={warnmsg} conv={convert} /> : null}
                        {editable() ?
                            <div data-list-edit-trigger="true" style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} onClick={ButtonClick}>
                                <IconButton data-list-edit-trigger="true" size="small" tabIndex={-1}>
                                    <Icon>arrow_right</Icon>
                                </IconButton>
                            </div>
                            : null}
                    </div>
                );
            }
            if (column.datatype === CELLTYPE.MASTER || column.datatype === CELLTYPE.SELECT || column.datatype === CELLTYPE.RADIO || 
                column.datatype === CELLTYPE.SPIN || column.datatype === CELLTYPE.MASTERREF ||
                column.datatype === CELLTYPE.MASTERCODE || column.datatype === CELLTYPE.MASTERASST || exmaster) {
                return (
                    <div style={{ position: 'rerative' }}>
                        {cellValue}
                        {warning ? <WarnTip msg={warnmsg} conv={convert} /> : null}
                        {column.datatype === CELLTYPE.SPIN && editable() ?
                            <div style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} onClick={SwitchClick}>
                                <IconButton size="small">
                                    <Icon>unfold_more</Icon>
                                </IconButton>
                            </div>
                            : null}
                        {column.datatype !== CELLTYPE.SPIN && editable() ?
                            <div data-list-edit-trigger="true" style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} onClick={ButtonClick}>
                                <IconButton data-list-edit-trigger="true" size="small" tabIndex={-1}>
                                    <Icon>arrow_right</Icon>
                                </IconButton>
                            </div>
                            : null}
                    </div>
                );
            }
        //    if (column.datatype === CELLTYPE.TAG) {
        //        return (
        //            <div style={{ position: 'rerative' }}>
        //                <TagRender/>
        //                {editable() ?
        //                    <div style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} onClick={ButtonClick}>
        //                        <IconButton size="small">
        //                            <Icon>arrow_right</Icon>
        //                        </IconButton>
        //                    </div>
        //                    : null}
        //            </div>
        //        );
        //    }
        } catch (error) {
            console.log(error);
        }
        return <div>{cellValue}</div>
    }
    return (
        <RenderBody />
    );
}
